// src/contexts/SubjectsNavigationContext.tsx
import React, { createContext, useState, useContext, ReactNode } from 'react';

interface SubjectsNavigationContextType {
    lastPath: string;
    setLastPath: (path: string) => void;
}

const SubjectsNavigationContext = createContext<SubjectsNavigationContextType | undefined>(undefined);

export const SubjectsNavigationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [lastPath, setLastPath] = useState('/subjects');

    return (
        <SubjectsNavigationContext.Provider value={{ lastPath, setLastPath }}>
            {children}
        </SubjectsNavigationContext.Provider>
    );
};

export const useSubjectsNavigation = () => {
    const context = useContext(SubjectsNavigationContext);
    if (!context) {
        throw new Error('useSubjectsNavigation must be used within a SubjectsNavigationProvider');
    }
    return context;
};
